import { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { getValeByEmpresaEstadoTipo } from "component/api";
import { Button } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Pagination } from "@mui/material";
import { Box } from "@mui/material";
import TagManager from "react-gtm-module";
import "./TableVales.css";

const tagManagerArgs = {
  dataLayer: {
    userId: "001",
    userProject: "project",
    page: "vale",
  },
  dataLayerName: "Vales",
};

const TableVales = () => {
  TagManager.dataLayer(tagManagerArgs);

  const [table, setTable] = useState(true);
  const [vales, setVales] = useState([]);

  const [totalPages, setTotalPages] = useState("");
  const [page, setPage] = useState(1);

  const handleChange = (event, value) => {
    setPage(value);
  };

  async function getValeByEmpresaEstadoTipoFunc(
    empresaId,
    estate,
    typeValeId,
    size,
    page
  ) {
    const res = await getValeByEmpresaEstadoTipo(
      empresaId,
      estate,
      typeValeId,
      size,
      page - 1
    );
    if (res.data.content.length > 0) {
      setTotalPages(res.data.totalPages);

      setVales(res.data.content);
    }
    if (res.data.content.length <= 0) {
      setVales("");
      setTotalPages(1);
    }
  }

  const handleChangeEstado = (event) => {
    setPage(1);
    setEstado(event.target.value);
  };
  const handleChangeTipoValeId = (event) => {
    setPage(1);
    setTipoValeId(event.target.value);
  };
  const [estado, setEstado] = useState("");
  const [tipoValeId, setTipoValeId] = useState("0");
  const [button, setButton] = useState(false);
  const empresaid = localStorage.getItem("empresaId");

  const [size, setSize] = useState(20);

  useEffect(() => {
    try {
      getValeByEmpresaEstadoTipoFunc(empresaid, estado, tipoValeId, size, page);
    } catch (err) {}
  }, [estado, tipoValeId, size, page]);

  function onClickVer(typeVale, IdVale) {
    localStorage.setItem("valeType", typeVale);
    localStorage.setItem("idvale", IdVale);
  }
  function buscar() {
    setTable(true);
    setButton(false);
  }

  function styleColorCategoría(value) {
    if (value == 1) {
      return "#009BDB";
    }
    if (value == 2) {
      return "rgb(128,0,128)";
    }
    if (value == 3) {
      return "red";
    }
  }
  const handleChangeFilas = (event) => {
    setSize(event.target.value);
    setPage(1);
  };

  const nombreEmnpresa = localStorage.getItem("empresaNombre");

  const tabla = (
    <div>
      <TableContainer component={Paper}>
        <Table className="table-vales" aria-label="customized table">
          <TableHead>
            <TableRow className="table-row">
              <TableCell className="table-cell-head">
                CATEGORÍA <UnfoldMoreIcon style={{ marginBottom: "-4%" }} />
              </TableCell>
              <TableCell className="table-cell-head">
                NÚMERO DE VALE{" "}
                <UnfoldMoreIcon style={{ marginBottom: "-4%" }} />
              </TableCell>
              <TableCell className="table-cell-head">
                ESTADO <UnfoldMoreIcon style={{ marginBottom: "-4%" }} />
              </TableCell>
              <TableCell className="table-cell-head">
                FECHA CREACION{" "}
                <UnfoldMoreIcon style={{ marginBottom: "-4%" }} />
              </TableCell>
              <TableCell className="table-cell-head">VER VALE</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {vales.length > 0 ? (
              vales
                .sort((a, b) => b.fechaCreacion - a.fechaCreacion)
                .map((item) => (
                  <TableRow key={item.id} className="table-row">
                    <TableCell
                      component="th"
                      scope="row"
                      style={{ color: styleColorCategoría(item.tipoVale.id) }}
                      className="table-cell-body"
                    >
                      {categoría(item.tipoVale.id)}
                    </TableCell>
                    <TableCell className="table-cell-body">{item.id}</TableCell>
                    <TableCell className="table-cell-body">
                      {item.estado}
                    </TableCell>
                    <TableCell className="table-cell-body">
                      {item.fechaCreacion}
                    </TableCell>
                    <TableCell className="table-cell-body">
                      {item.estado === "ACTIVO" ? (
                        <Link
                          style={{ textDecoration: "none" }}
                          onClick={() => onClickVer(item.tipoVale.id, item.id)}
                          to="/valeClass"
                        >
                          Ver
                        </Link>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={5}
                  sx={{
                    backgroundColor: "#F9CDD0",
                    border: "red 1px ridge",
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "3%",
                    marginBottom: "3%",
                    padding: "10px",
                  }}
                >
                  {estado !== ""
                    ? estado === "ACTIVO"
                      ? `La empresa ${nombreEmnpresa} no posee vales Activos, para visualizarlos deben ser generados previamente.`
                      : `La empresa ${nombreEmnpresa} no posee vales consumidos.`
                    : `La empresa ${nombreEmnpresa} no posee vales Activos o Consumidos.`}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <br />
      <div
        style={{
          justifyContent: "start",
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Box component="span">
          <Pagination
            count={Number(totalPages) || 1}
            page={page}
            onChange={handleChange}
            defaultPage={1}
            color="primary"
            size="large"
            showFirstButton
            showLastButton
          />
        </Box>
        <div
          style={{
            width: "50%",
            marginLeft: "15%",
            justifyContent: "start",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <InputLabel style={{ marginTop: "3%" }}>
            {" "}
            Filas por página{" "}
          </InputLabel>

          <FormControl
            style={{ marginLeft: "5%" }}
            className="form-control-vales-select"
          >
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={size}
              onChange={handleChangeFilas}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={15}>15</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={40}>40</MenuItem>
              <MenuItem value={60}>60</MenuItem>
              <MenuItem value={80}>80</MenuItem>
              <MenuItem value={5000}>TODAS</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
    </div>
  );

  function categoría(value) {
    if (value == 1) {
      return "Hasta 12 m3";
    }
    if (value == 2) {
      return "De 13 a 20 m3";
    }
    if (value == 3) {
      return "De 21 a 36 m3";
    }
  }
  return (
    <div style={{ marginTop: "5%" }}>
      <p style={{ fontSize: "28px", marginBottom: "0%" }}>
        Últimos movimientos de Vales
      </p>
      <div>
        <FormControl className="form-control-vales">
          <InputLabel style={{ fontSize: "20px", marginTop: "-15px" }} shrink>
            Categoría
          </InputLabel>
          <Select
            displayEmpty
            value={tipoValeId}
            onChange={handleChangeTipoValeId}
          >
            <MenuItem value={0}>Todas</MenuItem>
            <MenuItem value={1}>Hasta 12 m3</MenuItem>
            <MenuItem value={2}>De 13 a 20 m3</MenuItem>
            <MenuItem value={3}>De 21 a 36 m3</MenuItem>
          </Select>
        </FormControl>
        <FormControl className="form-control-vales">
          <InputLabel style={{ fontSize: "20px", marginTop: "-15px" }} shrink>
            Estado
          </InputLabel>
          <Select displayEmpty value={estado} onChange={handleChangeEstado}>
            <MenuItem value={""}>Todos</MenuItem>
            <MenuItem value={"ACTIVO"}>ACTIVO</MenuItem>
            <MenuItem value={"CONSUMIDO"}>CONSUMIDO</MenuItem>
          </Select>
        </FormControl>
        {button === true && (
          <Button
            style={{ margin: "5%" }}
            onClick={() => buscar()}
            variant="contained"
          >
            Buscar
          </Button>
        )}
      </div>

      {table === true && tabla}

      <Link
        to="/vales"
        style={{ textDecoration: "none" }}
      ></Link>

      <br />
    </div>
  );
};
export default TableVales;
